/* eslint-disable react/forbid-prop-types */
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Row, Column } from "../../../components/Grid/Grid.component";
import { H2 } from "../../../components/Typography/Typography.component";
import BorderInput from "../../../components/Form/BorderInput/BorderInput.component";
import Error from "../../../components/Error/ErrorMessage.component";

const SportCategoryForm = (props) => {
  const {
    register,
    errors,
    sportCategoryEditData,
    sportCategoryData,
    setSportCategoryData,
  } = props;

  useEffect(() => {
    if (sportCategoryEditData && sportCategoryData.title === "") {
      setSportCategoryData(sportCategoryEditData);
    }
  });

  return (
    <Column sub noPad>
      <Row>
        <Column width="100%" sub>
          <H2>Sport Category Details</H2>
        </Column>
      </Row>
      <Row>
        <Column width="50%" sub>
          <BorderInput
            header="Name"
            name="title"
            label=""
            type="text"
            value={sportCategoryData.title}
            register={register}
            required={{
              required: "please enter a Sport Category Name",
            }}
            error={errors.title && <Error message={errors.title.message} />}
          />
        </Column>
        <Column width="50%" sub>
          <BorderInput
            header="Description"
            name="description"
            label=""
            type="text"
            value={sportCategoryData.description}
            register={register}
            error={
              errors.description && (
                <Error message={errors.description.message} />
              )
            }
          />
        </Column>
      </Row>
    </Column>
  );
};

SportCategoryForm.defaultProps = {
  errors: {},
  sportCategoryEditData: undefined,
};

SportCategoryForm.propTypes = {
  register: PropTypes.func.isRequired,
  errors: PropTypes.object,
  sportCategoryEditData: PropTypes.any,
  sportCategoryData: PropTypes.any.isRequired,
  setSportCategoryData: PropTypes.func.isRequired,
};

export default SportCategoryForm;
